export default "__VITE_ASSET__CvwLTOtS__"